import React from "react";

import { Localized } from "fluent-react/compat";

const Button = ({ disabledSubmit, classCusto, submit, text }) => {
  return (
    <div className="container-default-button">
      <button
        className={`button ${classCusto} ${
          disabledSubmit ? "is-disabled" : ""
        }`}
        onClick={submit}
      >
        <span>
          <Localized id={text} />
        </span>
      </button>
    </div>
  );
};

export default Button;
